import React from 'react';
import { DynamicForm } from 'modules/account/components/DynamicForm/DynamicForm';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';

const AdditionalInfo: React.FC = () => (
    <DynamicForm pageName="additionalInfo"
    initialValues={ApiLocalStorage.get('user-data')} />
  );

export default AdditionalInfo;
